import React, { Component } from 'react';
import Slide from './Slide';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
import {
    getEventForExitWindow,
    getLeadFormTriggerCodeForNcr,
    setNCRLeadFormTriggerCode,
    setNCRLeadFormTriggerCodeBasedOnOccasion,
} from '../../../../../../util/leadFormUtility';
import { validatePhoneNumber } from '../../../../../../util/utility';
import { getCurrentPage } from '../../../../../../util/vmCookieHandler';
import moment from 'moment';

import {
    VENUE_CORPORATE_STANALONE,
    DESTINATION_WEDDING_MODEL,
    VENUE_MODEL,
    VENUE_CORPORATE_STANALONE_GURGAON,
} from '../../../../../../constants/constants';
import { Spinner } from 'react-bootstrap';
import styles from '../../../../../../styles/leadform.module.css';
import { isEqual } from 'lodash';


// class LeadFormSlide extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             currentSlide: {},
//             selectedValues: [],
//             isNextBtnVisible: true,
//             isPrevBtnVisible: false,
//             isLastBtn: false,
//             currentIndex: 0,
//             leadForm: {},
//             slideLength: 0,
//             qtext: '',
//             selectedYear: moment().year(),
//             selectedMonth: moment().month() + 1,
//         };
//     }

//     componentDidMount() {
//         if (!isEmpty(this.props.leadFormData)) {
//             this.setState({
//                 leadForm: this.props.leadFormData,
//                 currentSlide: this.props.leadFormData.slides[0],
//                 slideLength: this.props.leadFormData.slides.length,
//             });
//         }
//     }

//     componentDidUpdate(prevProps) {
//         const next = this.props.newLeadFormData;
//         const prev = prevProps.newLeadFormData;
//         const nextSlides = next && isArray(next.slides) ? next.slides : [];
//         // Redux gives a new object per LOAD_LEAD_FORM_DATA. Old check used only `_id`; when API omits it,
//         // `isEqual(undefined, undefined)` stayed true and the next slides never merged after city/Occasion fetch.
//         if (nextSlides.length > 0 && prev !== next) {
//             let leadForm = { ...this.state.leadForm };
//             leadForm.slides = leadForm.slides.filter(
//                 (item, index) => index <= this.state.currentIndex
//             );
//             leadForm.slides = leadForm.slides.concat(nextSlides);
//             this.setState(
//                 {
//                     leadForm: leadForm,
//                     slideLength: leadForm.slides.length,
//                 },
//                 () => {
//                     this.setButtonState(this.state.currentIndex + 1);
//                 }
//             );
//         }
//     }

//     handleMonthSelect = (month) => {
//         if (month !== this.state.selectedMonth) {
//             this.handleClearEventDate();
//         }
//         this.setState({
//             ...this.state,
//             selectedMonth: month,
//         },()=>{
//             this.handleNextClick(this.state.currentIndex    )
//         });
//     };
//     handleYearSelect = (year) => {
//         if (year !== this.state.selectedYear) {
//                 this.handleClearEventDate();
//         }
//         this.setState({
//             ...this.state,
//             selectedYear: year,
//         });
//     };

//     showMessage = (msg, msgtype) => {
//         this.props.notify(msg, msgtype);
//     };

//     setButtonState = (index) => {
//         let isPrevBtnVisble = index > 0;
//         let isNextBtnVisible = index <= this.state.slideLength - 1;
//         let isLastBtn = index === this.state.slideLength - 1;
//         this.setState({
//             currentSlide: this.state.leadForm.slides[index],
//             currentIndex: index,
//             isNextBtnVisible: isNextBtnVisible,
//             isPrevBtnVisible: isPrevBtnVisble,
//             isLastBtn: isLastBtn,
//         });
//     };

//     getOccasionCityCode = () => {
//         let event = this.getEventDetails();
//         return `new-${kebabCase(event.city)}-${kebabCase(event.occasion)}`;
//     };

//     handleNextClick = (index) => {
//         this.setState({ qtext: '' });
//         let validatation = this.validateCurrentSlide(this.state.currentSlide);
//         // setNCRLeadFormTriggerCode(this.state.currentSlide, this.props.selectedVenue,this.props.pageSource,this.props.leadFormTriggerCode,this.props.leadFormMode)
//         getEventForExitWindow(this.state.currentSlide, this.props.setSelectedCatagoryType);
//         if (!validatation.isValid) {
//             const msg =
//                 validatation.elements?.[0]?.errorMessage || 'Please complete this step';
//             this.props.notify(msg, 2);
//         } else {
//             let elements = this.state.currentSlide.elements;
//             if (elements && isArray(elements) && elements.length > 0) {
//                 try {
//                     let ncrLeadFormTriggerCode = getLeadFormTriggerCodeForNcr(
//                         this.props.selectedVenue,
//                         this.props.pageSource,
//                         getCurrentPage(),
//                         this.props.leadFormMode
//                     );
//                     if (ncrLeadFormTriggerCode && ncrLeadFormTriggerCode !== '') {
//                         this.props.createSuperEvent({
//                             event_name: `${ncrLeadFormTriggerCode}-${elements[0].analyticsTriggerName}`,
//                             action_name: 'next-slide',
//                             feature_name: 'lead-form',
//                             segment_name: 'pre-otp-slide',
//                         });
//                         this.props.createSuperEvent({
//                             event_name: `${ncrLeadFormTriggerCode}-${
//                                 elements[0].analyticsTriggerName
//                             }-${this.props.leadFormTriggerCode ?? 'user'}`,
//                             action_name: 'next-slide',
//                             feature_name: 'lead-form',
//                             segment_name: 'pre-otp-slide',
//                         });
//                     }

//                     this.props.createSuperEvent({
//                         event_name: `${this.props.pageSource || 'ncr'}-${
//                             elements[0].analyticsTriggerName
//                         }`,
//                         action_name: 'next-slide',
//                         feature_name: 'lead-form',
//                         segment_name: 'pre-otp-slide',
//                     });
//                     this.props.createSuperEvent({
//                         event_name: `${this.props.pageSource || 'ncr'}-${
//                             elements[0].analyticsTriggerName
//                         }-${this.props.leadFormTriggerCode ?? 'user'}`,
//                         action_name: 'next-slide',
//                         feature_name: 'lead-form',
//                         segment_name: 'pre-otp-slide',
//                     });
//                 } catch (e) {
//                     console.warn('Lead form analytics skipped:', e);
//                 }
//             }
//             const eventDetails = this.getEventDetails();
//             if (this.state.currentSlide.isTriggerSlide) {
//                 this.finalSubmit();
//             } else if (this.state.currentSlide.isContinuingSlide) {
//                 if (
//                     this.state.currentSlide.continueCode === 'occasion-only' ||
//                     this.state.currentSlide.continueCode === 'faridabad-stand-alone' 
//                 ) {
//                     if (!isEmpty(this.props.newLeadFormData)) {
//                         this.setButtonState(index + 1);
//                     } else {
//                         this.props.fetchNextSlide(
//                             this.props.selectedVenue.city_slug,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                     }
//                 } else if (this.state.currentSlide.continueCode === 'occasion-city' || this.state.currentSlide.continueCode === 'jaipur-and-bangalore-form') {
//                     let code = this.getOccasionCityCode();
//                     if (
//                         code &&
//                         this.props.newLeadFormData &&
//                         code === this.props.newLeadFormData.code
//                     ) {
//                         this.setButtonState(index + 1);
//                     } else {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                     }
//                 } else if (this.state.currentSlide.continueCode === 'makeup-form') {
//                     if (isEmpty(this.props.newLeadFormData)) {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                     } else {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                         this.setButtonState(index + 1);
//                     }

//                     // this.setButtonState(index + 1);
//                 } 
//                 else if (this.state.currentSlide.continueCode === 'destination-wedding-v1' || this.state.currentSlide.continueCode === 'jaipur-destination-wedding-v1') {
//                     if (isEmpty(this.props.newLeadFormData)) {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                     } else {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                         this.setButtonState(index + 1);
//                     }

//                     // this.setButtonState(index + 1);
//                 } else if (  this.state.currentSlide.continueCode === VENUE_CORPORATE_STANALONE || this.state.currentSlide.continueCode === VENUE_CORPORATE_STANALONE_GURGAON) {
//                     if (isEmpty(this.props.newLeadFormData)) {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                     } else {
//                         this.props.fetchNextSlide(
//                             eventDetails.city,
//                             this.state.currentSlide.continueCode,
//                             eventDetails.category
//                         );
//                         this.setButtonState(index + 1);
//                     }

//                     // this.setButtonState(index + 1);
//                 }
//             } else {
//                 this.setButtonState(index + 1);
//             }
//         }
//     };

//     validateCurrentSlide = (currentSlide) => {
//         let result = {
//             isValid: true,
//         };
//         let requiredElements = currentSlide.elements.filter((item) => item.isRequired);
//         if (requiredElements && requiredElements.length > 0) {
//             let inValidElements = requiredElements.filter((item) => !this.validateElement(item));
//             if (inValidElements && inValidElements.length !== 0) {
//                 result.elements = inValidElements;
//                 result.isValid = false;
//             }
//             return result;
//         } else {
//             return result;
//         }
//     };

//     validateElement = (element) => {
//         let isValid = false;
//         if (element.elementType === 'radio' || element.elementType === 'checkbox') {
//             let array = element.options.filter((item) => !!item.isSelected);
//             isValid = array.length > 0;
//         } else if (element.elementType === 'date') {
//             isValid = !!element.selectedValue;
//         } else if (element.elementType === 'text') {
//             isValid = !!element.selectedValue;
//             if (element.textLabel == 'Phone') {
//                 isValid = validatePhoneNumber(element.selectedValue.phone);
//             }
//         }
//         return isValid;
//     };

//     handleBackClick = (index) => {
//         this.setButtonState(index - 1);
//     };

//     handleOptionSelect = (slideId, elementId, optionId, optionValue) => {
//         let leadForm = this.state.leadForm;
//         leadForm.slides = leadForm.slides.map((slide) => {
//             if (slide._id === slideId) {
//                 slide.elements = slide.elements.map((element) => {
//                     if (element._id === elementId) {
//                         let selectedIndex = 0;
//                         element.options =
//                             element.options &&
//                             element.options.length > 0 &&
//                             element.options.map((option, index) => {
//                                 option.isSelected =
//                                     toString(option.value) === toString(optionValue);
//                                 if (option.isSelected) {
//                                     selectedIndex = index;
//                                 }
//                                 return option;
//                             });
//                         let option = element.options[0];
//                         element.options[0] = element.options[selectedIndex];
//                         element.options[selectedIndex] = option;
//                     }
//                     return element;
//                 });
//                 return slide;
//             }
//             return slide;
//         });
//         this.setState({ leadForm: leadForm }, () => {
//             this.handleNextClick(this.state.currentIndex);
//         });
//     };

//     handleMultiOptionSelect = (slideId, elementId, optionId, optionValue) => {
//         let leadForm = this.state.leadForm;
//         leadForm.slides = leadForm.slides.map((slide) => {
//             if (slide._id === slideId) {
//                 slide.elements = slide.elements.map((element) => {
//                     if (element._id === elementId) {
//                         element.options =
//                             element.options &&
//                             element.options.length > 0 &&
//                             element.options.map((option) => {
//                                 if (option._id === optionId) {
//                                     option.isSelected = !!!option.isSelected;
//                                 }
//                                 return option;
//                             });
//                     }
//                     return element;
//                 });
//             }
//             return slide;
//         });
//     };

//     handleDateSelect = (slideId, elementId, optionValue) => {
//         let leadForm = this.state.leadForm;
//         leadForm.slides = leadForm.slides.map((slide) => {
//             if (slide._id === slideId) {
//                 slide.elements = slide.elements.map((element) => {
//                     if (element._id === elementId) {
//                         element.selectedValue = optionValue;
//                     }
//                     return element;
//                 });
//             }
//             return slide;
//         });

//         let event = this.getEventDetails();
//         if (
//             this.props.leadFormMode == VENUE_MODEL &&
//             event.category &&
//             event.category == 'Wedding'
//         ) {
//             this.props.fetchHeavyDate({
//                 event_type: event.category,
//                 event_date: moment(event.date).toISOString(),
//             });
//         } else if (this.props.leadFormMode == DESTINATION_WEDDING_MODEL) {
//             this.props.fetchHeavyDate({
//                 event_type: 'Wedding',
//                 event_date: moment(event.date).toISOString(),
//             });
//         }

//         this.setState({ leadForm: leadForm }, () => {
//             this.handleNextClick(this.state.currentIndex);
//         });
//     };

//     handleTextOptionFocus = (value) => {};

//     handleTextOptionSelect = (slideId, elementId, optionValue) => {
//         let leadForm = this.state.leadForm;
//         leadForm.slides = leadForm.slides.map((slide) => {
//             if (slide._id === slideId) {
//                 slide.elements = slide.elements.map((element) => {
//                     if (element._id === elementId) {
//                         element.selectedValue = optionValue;
//                     }
//                     return element;
//                 });
//             }
//             return slide;
//         });
//         this.setState({ leadForm: leadForm });
//     };

//     notifyToUser = (message) => {};

//     finalSubmit = () => {
//         let event = this.getEventDetails();
//         this.props.submitEvent(event);
//     };

//     getEventDetails = () => {
//         let event = {};
//         this.state.leadForm.slides.forEach((slideItem) => {
//             slideItem.elements.forEach((elementItem) => {
//                 event[elementItem.keyName] = this.getSelectedValueFromElement(elementItem);
//             });
//         });
//         if (!isEmpty(this.props.selectedVenue)) {
//             event.city = this.props.selectedVenue.city_slug;
//         }
//         return event;
//     };

//     handleClearEventDate = () => {
//         this.state.leadForm.slides.forEach((slideItem) => {
//             slideItem.elements.forEach((elementItem) => {
//                 if (elementItem.elementType === 'date') {
//                     delete elementItem.selectedValue;
//                 }
//             });
//         });
//     };

//     getSelectedValueFromElement = (element) => {
//         if (element.elementType === 'radio') {
//             return element.options.filter((item) => !!item.isSelected).map((item) => item.value)[0];
//         } else if (element.elementType === 'date') {
//             return element.selectedValue;
//         } else if (element.elementType === 'text') {
//             return element.selectedValue;
//         } else if (element.elementType === 'checkbox') {
//             return element.options.filter((item) => !!item.isSelected).map((item) => item.value)[0];
//         }
//     };

//     handleOptionSearch = (qtext) => {
//         this.setState({ qtext: qtext });
//     };

//     getInitialDateForDateSlide = () => {
//         let selectedMonth = this.state.selectedMonth;
//         let selectedYear = this.state.selectedYear;
//         const currentDate = moment();

//         if (selectedMonth === currentDate.month() + 1 && selectedYear === currentDate.year()) {
//             return currentDate;
//         } else {
//             return moment()
//                 .year(selectedYear)
//                 .month(selectedMonth - 1)
//                 .startOf('month');
//         }
//     };

//     render() {
//         return isEmpty(this.state.currentSlide?.elements) ? (
//             <div
//                 className={styles['lead-form-slide-spinner-wrap']}
//                 aria-busy="true"
//                 aria-label="Loading slide"
//             >
//                 <Spinner animation="border" role="status" />
//             </div>
//         ) : (
//             <Slide
//                 selectedMonth={this.state.selectedMonth}
//                 selectedYear={this.state.selectedYear}
//                 handleMonthSelect={this.handleMonthSelect}
//                 handleYearSelect={this.handleYearSelect}
//                 event_date={this.getEventDetails()?.date}
//                 heavyDate={this.props.heavyDate}
//                 leadFormMode={this.props.leadFormMode}
//                 elements={this.state.currentSlide.elements}
//                 questionText={this.state.currentSlide.questionText}
//                 handleOptionSelect={this.handleOptionSelect}
//                 slideId={this.state.currentSlide._id}
//                 handleBackAndNext={this.handleBackAndNext}
//                 handleNextClick={this.handleNextClick}
//                 handleBackClick={this.handleBackClick}
//                 isLastBtn={this.state.isLastBtn}
//                 isTriggerSlide={this.state.currentSlide.isTriggerSlide}
//                 isNextBtnVisible={this.state.isNextBtnVisible}
//                 isPrevBtnVisible={this.state.isPrevBtnVisible}
//                 currentIndex={this.state.currentIndex}
//                 amplitudeEventName={this.state.currentSlide.targetId}
//                 handleMultiOptionSelect={this.handleMultiOptionSelect}
//                 handleDateSelect={this.handleDateSelect}
//                 handleTextOptionSelect={this.handleTextOptionSelect}
//                 isLoadingLeadForm={this.props.isLoadingLeadForm}
//                 isPlanningEvent={this.props.isPlanningEvent}
//                 handleTextOptionFocus={this.handleTextOptionFocus}
//                 handleOptionSearch={this.handleOptionSearch}
//                 qtext={this.state.qtext}
//                 countryCodeDict={this.props.countryCodeDict}
//                 nation={this.props.nation}
//                 getWhatsappToggleStatus={this.props.getWhatsappToggleStatus}
//                 initialDate={this.getInitialDateForDateSlide()}
//             />
//         );
//     }
// }

// export default LeadFormSlide;



class LeadFormSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: {},
            selectedValues: [],
            isNextBtnVisible: true,
            isPrevBtnVisible: false,
            isLastBtn: false,
            currentIndex: 0,
            leadForm: {},
            slideLength: 0,
            qtext: '',
            selectedYear: moment().year(),
            selectedMonth: moment().month() + 1,
        };
    }

    componentDidMount() {
        if (!isEmpty(this.props.leadFormData)) {
            this.setState({
                leadForm: this.props.leadFormData,
                currentSlide: this.props.leadFormData.slides[0],
                slideLength: this.props.leadFormData.slides.length,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.newLeadFormData &&
            !isEqual(prevProps.newLeadFormData._id, this.props.newLeadFormData._id)
        ) {
            let leadForm = this.state.leadForm;
            leadForm.slides = leadForm.slides.filter(
                (item, index) => index <= this.state.currentIndex
            );
            const nextSlides = this.props.newLeadFormData.slides;
            leadForm.slides = leadForm.slides.concat(
                Array.isArray(nextSlides) ? nextSlides : []
            );
            this.setState(
                {
                    leadForm: leadForm,
                    slideLength: leadForm.slides.length,
                },
                () => {
                    this.setButtonState(this.state.currentIndex + 1);
                }
            );
        }
    }

    handleMonthSelect = (month) => {
        if (month !== this.state.selectedMonth) {
            this.handleClearEventDate();
        }
        this.setState({
            ...this.state,
            selectedMonth: month,
        },()=>{
            this.handleNextClick(this.state.currentIndex    )
        });
    };
    handleYearSelect = (year) => {
        if (year !== this.state.selectedYear) {
                this.handleClearEventDate();
        }
        this.setState({
            ...this.state,
            selectedYear: year,
        });
    };

    showMessage = (msg, msgtype) => {
        this.props.notify(msg, msgtype);
    };

    setButtonState = (index) => {
        let isPrevBtnVisble = index > 0;
        let isNextBtnVisible = index <= this.state.slideLength - 1;
        let isLastBtn = index === this.state.slideLength - 1;
        this.setState({
            currentSlide: this.state.leadForm.slides[index],
            currentIndex: index,
            isNextBtnVisible: isNextBtnVisible,
            isPrevBtnVisible: isPrevBtnVisble,
            isLastBtn: isLastBtn,
        });
    };

    getOccasionCityCode = () => {
        let event = this.getEventDetails();
        const occasion = event.occasion ?? event.category;
        return `new-${kebabCase(event.city)}-${kebabCase(occasion)}`;
    };

    handleNextClick = (index) => {
        this.setState({ qtext: '' });
        let validatation = this.validateCurrentSlide(this.state.currentSlide);
        // setNCRLeadFormTriggerCode(this.state.currentSlide, this.props.selectedVenue,this.props.pageSource,this.props.leadFormTriggerCode,this.props.leadFormMode)
        getEventForExitWindow(this.state.currentSlide, this.props.setSelectedCatagoryType);
        if (!validatation.isValid) {
            this.props.notify(validatation.elements[0].errorMessage, 2);
        } else {
            let elements = this.state.currentSlide.elements;
            if (elements && isArray(elements) && elements.length > 0) {
                let ncrLeadFormTriggerCode = getLeadFormTriggerCodeForNcr(
                    this.props.selectedVenue,
                    this.props.pageSource,
                    getCurrentPage(),
                    this.props.leadFormMode
                );
                if (ncrLeadFormTriggerCode && ncrLeadFormTriggerCode !== '') {
                    this.props.createSuperEvent({
                        event_name: `${ncrLeadFormTriggerCode}-${elements[0].analyticsTriggerName}`,
                        action_name: 'next-slide',
                        feature_name: 'lead-form',
                        segment_name: 'pre-otp-slide',
                    });
                    this.props.createSuperEvent({
                        event_name: `${ncrLeadFormTriggerCode}-${
                            elements[0].analyticsTriggerName
                        }-${this.props.leadFormTriggerCode ?? 'user'}`,
                        action_name: 'next-slide',
                        feature_name: 'lead-form',
                        segment_name: 'pre-otp-slide',
                    });
                }

                this.props.createSuperEvent({
                    event_name: `${this.props.pageSource || 'ncr'}-${
                        elements[0].analyticsTriggerName
                    }`,
                    action_name: 'next-slide',
                    feature_name: 'lead-form',
                    segment_name: 'pre-otp-slide',
                });
                this.props.createSuperEvent({
                    event_name: `${this.props.pageSource || 'ncr'}-${
                        elements[0].analyticsTriggerName
                    }-${this.props.leadFormTriggerCode ?? 'user'}`,
                    action_name: 'next-slide',
                    feature_name: 'lead-form',
                    segment_name: 'pre-otp-slide',
                });
            }
            const eventDetails = this.getEventDetails();
            if (this.state.currentSlide.isTriggerSlide) {
                this.finalSubmit();
            } else if (this.state.currentSlide.isContinuingSlide) {
                if (
                    this.state.currentSlide.continueCode === 'occasion-only' ||
                    this.state.currentSlide.continueCode === 'faridabad-stand-alone' 
                ) {
                    if (!isEmpty(this.props.newLeadFormData)) {
                        this.setButtonState(index + 1);
                    } else {
                        this.props.fetchNextSlide(
                            this.props.selectedVenue.city_slug,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                    }
                } else if (this.state.currentSlide.continueCode === 'occasion-city' || this.state.currentSlide.continueCode === 'jaipur-and-bangalore-form') {
                    let code = this.getOccasionCityCode();
                    if (
                        code &&
                        this.props.newLeadFormData &&
                        code === this.props.newLeadFormData.code
                    ) {
                        this.setButtonState(index + 1);
                    } else {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                    }
                } else if (this.state.currentSlide.continueCode === 'makeup-form') {
                    if (isEmpty(this.props.newLeadFormData)) {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                    } else {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                        this.setButtonState(index + 1);
                    }

                    // this.setButtonState(index + 1);
                } 
                else if (this.state.currentSlide.continueCode === 'destination-wedding-v1' || this.state.currentSlide.continueCode === 'jaipur-destination-wedding-v1') {
                    if (isEmpty(this.props.newLeadFormData)) {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                    } else {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                        this.setButtonState(index + 1);
                    }

                    // this.setButtonState(index + 1);
                } else if (  this.state.currentSlide.continueCode === VENUE_CORPORATE_STANALONE || this.state.currentSlide.continueCode === VENUE_CORPORATE_STANALONE_GURGAON) {
                    if (isEmpty(this.props.newLeadFormData)) {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                    } else {
                        this.props.fetchNextSlide(
                            eventDetails.city,
                            this.state.currentSlide.continueCode,
                            eventDetails.category
                        );
                        this.setButtonState(index + 1);
                    }

                    // this.setButtonState(index + 1);
                }
            } else {
                this.setButtonState(index + 1);
            }
        }
    };

    validateCurrentSlide = (currentSlide) => {
        let result = {
            isValid: true,
        };
        let requiredElements = currentSlide.elements.filter((item) => item.isRequired);
        if (requiredElements && requiredElements.length > 0) {
            let inValidElements = requiredElements.filter((item) => !this.validateElement(item));
            if (inValidElements && inValidElements.length !== 0) {
                result.elements = inValidElements;
                result.isValid = false;
            }
            return result;
        } else {
            return result;
        }
    };

    validateElement = (element) => {
        let isValid = false;
        if (element.elementType === 'radio' || element.elementType === 'checkbox') {
            let array = element.options.filter((item) => !!item.isSelected);
            isValid = array.length > 0;
        } else if (element.elementType === 'date') {
            isValid = !!element.selectedValue;
        } else if (element.elementType === 'text') {
            isValid = !!element.selectedValue;
            if (element.textLabel == 'Phone') {
                isValid = validatePhoneNumber(element.selectedValue.phone);
            }
        }
        return isValid;
    };

    handleBackClick = (index) => {
        this.setButtonState(index - 1);
    };

    handleOptionSelect = (slideId, elementId, optionId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        let selectedIndex = 0;
                        element.options =
                            element.options &&
                            element.options.length > 0 &&
                            element.options.map((option, index) => {
                                option.isSelected =
                                    toString(option.value) === toString(optionValue);
                                if (option.isSelected) {
                                    selectedIndex = index;
                                }
                                return option;
                            });
                        let option = element.options[0];
                        element.options[0] = element.options[selectedIndex];
                        element.options[selectedIndex] = option;
                    }
                    return element;
                });
                return slide;
            }
            return slide;
        });
        this.setState({ leadForm: leadForm }, () => {
            this.handleNextClick(this.state.currentIndex);
        });
    };

    handleMultiOptionSelect = (slideId, elementId, optionId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.options =
                            element.options &&
                            element.options.length > 0 &&
                            element.options.map((option) => {
                                if (option._id === optionId) {
                                    option.isSelected = !!!option.isSelected;
                                }
                                return option;
                            });
                    }
                    return element;
                });
            }
            return slide;
        });
    };

    handleDateSelect = (slideId, elementId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.selectedValue = optionValue;
                    }
                    return element;
                });
            }
            return slide;
        });

        let event = this.getEventDetails();
        if (
            this.props.leadFormMode == VENUE_MODEL &&
            event.category &&
            event.category == 'Wedding'
        ) {
            this.props.fetchHeavyDate({
                event_type: event.category,
                event_date: moment(event.date).toISOString(),
            });
        } else if (this.props.leadFormMode == DESTINATION_WEDDING_MODEL) {
            this.props.fetchHeavyDate({
                event_type: 'Wedding',
                event_date: moment(event.date).toISOString(),
            });
        }

        this.setState({ leadForm: leadForm }, () => {
            this.handleNextClick(this.state.currentIndex);
        });
    };

    handleTextOptionFocus = (value) => {};

    handleTextOptionSelect = (slideId, elementId, optionValue) => {
        let leadForm = this.state.leadForm;
        leadForm.slides = leadForm.slides.map((slide) => {
            if (slide._id === slideId) {
                slide.elements = slide.elements.map((element) => {
                    if (element._id === elementId) {
                        element.selectedValue = optionValue;
                    }
                    return element;
                });
            }
            return slide;
        });
        this.setState({ leadForm: leadForm });
    };

    notifyToUser = (message) => {};

    finalSubmit = () => {
        let event = this.getEventDetails();
        this.props.submitEvent(event);
    };

    getEventDetails = () => {
        let event = {};
        const slides = this.state.leadForm?.slides;
        if (!Array.isArray(slides)) {
            if (!isEmpty(this.props.selectedVenue)) {
                event.city = this.props.selectedVenue.city_slug;
            }
            return event;
        }
        slides.forEach((slideItem) => {
            if (!slideItem?.elements) return;
            slideItem.elements.forEach((elementItem) => {
                if (elementItem?.keyName) {
                    event[elementItem.keyName] = this.getSelectedValueFromElement(elementItem);
                }
            });
        });
        if (!isEmpty(this.props.selectedVenue)) {
            event.city = this.props.selectedVenue.city_slug;
        }
        return event;
    };

    handleClearEventDate = () => {
        const slides = this.state.leadForm?.slides;
        if (!Array.isArray(slides)) return;
        slides.forEach((slideItem) => {
            if (!slideItem?.elements) return;
            slideItem.elements.forEach((elementItem) => {
                if (elementItem.elementType === 'date') {
                    delete elementItem.selectedValue;
                }
            });
        });
    };

    getSelectedValueFromElement = (element) => {
        if (element.elementType === 'radio') {
            return element.options.filter((item) => !!item.isSelected).map((item) => item.value)[0];
        } else if (element.elementType === 'date') {
            return element.selectedValue;
        } else if (element.elementType === 'text') {
            return element.selectedValue;
        } else if (element.elementType === 'checkbox') {
            return element.options.filter((item) => !!item.isSelected).map((item) => item.value)[0];
        }
    };

    handleOptionSearch = (qtext) => {
        this.setState({ qtext: qtext });
    };

    getInitialDateForDateSlide = () => {
        let selectedMonth = this.state.selectedMonth;
        let selectedYear = this.state.selectedYear;
        const currentDate = moment();

        if (selectedMonth === currentDate.month() + 1 && selectedYear === currentDate.year()) {
            return currentDate;
        } else {
            return moment()
                .year(selectedYear)
                .month(selectedMonth - 1)
                .startOf('month');
        }
    };

    render() {
        return isEmpty(this.state.currentSlide?.elements) ? (
            <div
                className={styles['lead-form-slide-spinner-wrap']}
                aria-busy="true"
                aria-label="Loading slide"
            >
                <Spinner animation="border" role="status" />
            </div>
        ) : (
            <Slide
                selectedMonth={this.state.selectedMonth}
                selectedYear={this.state.selectedYear}
                handleMonthSelect={this.handleMonthSelect}
                handleYearSelect={this.handleYearSelect}
                event_date={this.getEventDetails()?.date}
                heavyDate={this.props.heavyDate}
                leadFormMode={this.props.leadFormMode}
                elements={this.state.currentSlide.elements}
                questionText={this.state.currentSlide.questionText}
                handleOptionSelect={this.handleOptionSelect}
                slideId={this.state.currentSlide._id}
                handleBackAndNext={this.handleBackAndNext}
                handleNextClick={this.handleNextClick}
                handleBackClick={this.handleBackClick}
                isLastBtn={this.state.isLastBtn}
                isTriggerSlide={this.state.currentSlide.isTriggerSlide}
                isNextBtnVisible={this.state.isNextBtnVisible}
                isPrevBtnVisible={this.state.isPrevBtnVisible}
                currentIndex={this.state.currentIndex}
                amplitudeEventName={this.state.currentSlide.targetId}
                handleMultiOptionSelect={this.handleMultiOptionSelect}
                handleDateSelect={this.handleDateSelect}
                handleTextOptionSelect={this.handleTextOptionSelect}
                isLoadingLeadForm={this.props.isLoadingLeadForm}
                isPlanningEvent={this.props.isPlanningEvent}
                handleTextOptionFocus={this.handleTextOptionFocus}
                handleOptionSearch={this.handleOptionSearch}
                qtext={this.state.qtext}
                countryCodeDict={this.props.countryCodeDict}
                nation={this.props.nation}
                getWhatsappToggleStatus={this.props.getWhatsappToggleStatus}
                initialDate={this.getInitialDateForDateSlide()}
            />
        );
    }
}

export default LeadFormSlide;
